import { z } from 'zod';

// Base search schema with all common search functionality
export const zSearch = z.object({
  search: z
    .string()
    .transform((val) => (val && val.trim() ? val.trim() : ''))
    .optional(),
  archived: z.enum(['active', 'archived', 'all']).optional(),
  active: z.boolean().optional(),
  sortKey: z.string().optional(),
  sortDirection: z.enum(['asc', 'desc']).default('asc').optional(),
  limit: z.number().min(1).max(1000).default(25).optional(),
  offset: z.number().min(0).optional(),
});

// Material search with specific defaults and sort key transformation
export const zMaterialSearch = zSearch.extend({
  sortKey: z
    .string()
    .optional()
    .transform((val) => (val && val.trim() ? val.trim() : 'createdAt')),
  sortDirection: z.enum(['asc', 'desc']).optional().default('desc'),
  limit: z.number().min(1).max(1000).default(25),
  offset: z.number().min(0).default(0),
});

// Cleanup search with specific defaults and sort key transformation
export const zCleanupSearch = zSearch.extend({
  sortKey: z
    .string()
    .optional()
    .transform((val) => (val && val.trim() ? val.trim() : 'position')),
  sortDirection: z.enum(['asc', 'desc']).optional().default('asc'),
  limit: z.number().min(1).max(1000).default(10),
  offset: z.number().min(0).default(0),
});

export type SearchParams = z.infer<typeof zSearch>;
